const $ = require('jquery');
const config = {
  maskSelector: '.hf-mask',
  maskOpenClass: 'hf-mask--open',
};

class HeaderMask {
  constructor() {
    this.show = this.show.bind(this);
    this._getMask = this._getMask.bind(this);
  }

  _triggerHoverintent() {
    $(this).trigger({
      type: 'hoverintent',
      target: this,
    });
    $(document).trigger('showSimpleFlyout', false);
    $(document).trigger('closeAllMenusAndMask');
    $(document).trigger('closeNavLinkDropdowns');
  }

  _getMask() {
    let $mask = $(config.maskSelector);
    if (!$mask.length) {
      $mask = $('<div class="hf-mask"></div>').appendTo('body');
      let triggerHoverIntent = this._triggerHoverintent;
      $mask.hoverIntent({
        over: triggerHoverIntent,
        out: $.noop,
      });
      $mask.on('click touchend', () => {
        $(document).trigger('showSimpleFlyout', false);
        $(document).trigger('closeAllMenusAndMask');
        $(document).trigger('closeNavLinkDropdowns');
      });
    }
    return $mask;
  }

  destroy() {
    $(config.maskSelector).off().remove();
  }

  show(event, open) {
    let maskShown = typeof open === 'undefined' ? true : open;
    this._getMask().toggleClass(config.maskOpenClass, maskShown);
  }

  init() {
    $(document).on('headerMask-show', this.show);
  }
}

module.exports = new HeaderMask();
